import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalOptionPanelComponent } from '../../modal-option-panel/modal-option-panel.component';
import { LanguageService } from 'src/app/services/account/language.service';
import { SettingsService } from 'src/app/services/account/settings.service';

@Component({
  standalone: true,
  selector: 'app-account-verification-result-step',
  templateUrl: './verification-result-step.component.html',
  styleUrls: ['./verification-result-step.component.scss'],
  imports: [CommonModule, ModalOptionPanelComponent]
})
export class VerificationResultStepComponent {
  @Input() verifyFailed: boolean = false;

  constructor(
    public languageService: LanguageService,
    public settingsService: SettingsService
  ) {}
}
